import { FlexColumn, FlexRow } from '@interco/inter-ui/components/Flex'
import { Skeleton } from '@interco/inter-ui/components/Skeleton'
import { Spacing } from '@interco/inter-ui/components/Spacing'
import { Card } from '@interco/inter-ui/components/Card'
import { Divider } from '@interco/inter-toranja'

interface AccountInfoSkeletonProps {
  isAR?: boolean
}

export const AccountInfoSkeleton = ({ isAR = false }: AccountInfoSkeletonProps) =>
  isAR ? (
    <>
      <FlexColumn className="px-8 mt-6" gap="10px">
        <Skeleton width="200px" height="28px" />
        <Spacing mb="xs" />
        <FlexColumn gap="28px">
          <FlexRow gap="16px" justifyContent="space-between" alignItems="center">
            <FlexRow gap="16px" alignItems="center" justifyContent="flex-start">
              <Skeleton width="24px" height="24px" />
              <Skeleton width="100px" height="24px" />
            </FlexRow>
            <Skeleton width="24px" height="24px" />
          </FlexRow>
          {Array.from(Array(3).keys()).map(() => (
            <>
              <FlexRow gap="8px" alignItems="center" justifyContent="space-between">
                <Skeleton width="100px" height="16px" />
                <Skeleton width="100px" height="16px" />
              </FlexRow>
            </>
          ))}
          <Spacing mb="xs" />
        </FlexColumn>
        <Divider variant="solid" />
      </FlexColumn>

      <Spacing my="sm" />

      <FlexColumn className="px-8 mt-6" gap="10px">
        <Spacing mb="xxxs" />
        <FlexColumn gap="28px">
          <FlexRow gap="16px" justifyContent="space-between" alignItems="center">
            <FlexRow gap="16px" alignItems="center" justifyContent="flex-start">
              <Skeleton width="24px" height="24px" />
              <Skeleton width="100px" height="24px" />
            </FlexRow>
            <Skeleton width="24px" height="24px" />
          </FlexRow>
          <FlexRow gap="8px" alignItems="center" justifyContent="space-between">
            <Skeleton width="100px" height="16px" />
            <Skeleton width="100px" height="16px" />
          </FlexRow>
          <Spacing mb="xs" />
        </FlexColumn>
      </FlexColumn>
    </>
  ) : (
    <>
      <FlexColumn className="px-6 mt-4" gap="8px">
        <Skeleton width="200px" height="25px" />
        <Spacing mb="xxxs" />
        {Array.from(Array(2).keys()).map((index) => (
          <Card key={index}>
            <Skeleton width="60%" height="20px" />
            <Spacing mb="xxs" />

            <Divider variant="solid" />

            <Spacing mb="xs" />
            <FlexColumn gap="8px">
              <Skeleton width="20%" height="15px" />
              <Skeleton width="40%" height="15px" />
            </FlexColumn>
          </Card>
        ))}
      </FlexColumn>
      <FlexColumn className="px-6" gap="8px">
        <Skeleton width="100px" height="25px" />
        <Spacing mb="xxxs" />
        {Array.from(Array(4).keys()).map((index) => (
          <FlexColumn
            key={index}
            className="p-4 border border-solid border-inter-gray-200 rounded-lg"
          >
            <Skeleton width="60%" height="20px" />
          </FlexColumn>
        ))}
      </FlexColumn>
    </>
  )
